import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import {
  FETCH_PROMOTIONS,
  FETCH_PROMOTIONS_FAILURE,
  FETCH_PROMOTIONS_SUCCESS,
  Promotion
} from 'src/redux/promotionsReducer'

interface Response {
  mobile_listings: Promotion[]
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchMobileListingsFlow(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const response: Response = yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${action.payload}/mobile_listings`,
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(FETCH_PROMOTIONS_SUCCESS(response.mobile_listings))
  } catch {
    yield put(FETCH_PROMOTIONS_FAILURE())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchMobileListingsSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_PROMOTIONS, FetchMobileListingsFlow)
}
